import request from '@/utils/request'

let bannerApi = {
	bannerList(data, errorback) {
		return request._get('/shop/setting.banner/index', data, errorback);
	},
	bannerAdd(data, errorback) {
		return request._post('/shop/setting.banner/add', data, errorback);
	},
  bannerEdit(data, errorback) {
		return request._post('/shop/setting.banner/edit', data, errorback);
	},
  bannerDetail(data, errorback) {
		return request._get('/shop/setting.banner/detail', data, errorback);
	},
  bannerDelete(data, errorback) {
		return request._get('/shop/setting.banner/delete', data, errorback);
	},
	// 业务场景类型选项（供新增/编辑时下拉选择）
	bannerBizTypeOptions(data, errorback) {
		return request._get('/shop/setting.banner/bizTypeOptions', data || {}, errorback);
	},
}
export default bannerApi;



// WEBPACK FOOTER //
// ./src/api/banner.js